<template>
  <div>
    <markdown-document-modal />
    <sharing-modal />
    <app-share-modal />
    <jit-enable-modal />
  </div>
</template>

<script>
import MarkdownDocumentModal from './MarkdownDocumentModal.vue';
import SharingModal from './modals/SharePageModal.vue';
import AppShareModal from './modals/AppShareModal.vue';
import JitEnableModal from './modals/JitEnableModal.vue';

export default {
  components: {
    MarkdownDocumentModal,
    SharingModal,
    AppShareModal,
    JitEnableModal,
  },
};
</script>
